import { auth, signInWithEmailAndPassword } from "../services/firebase";

signInWithEmailAndPassword(auth, "jplattus@peccosystems.com", "Monos2103")
  .then((userCredential) => {
    // Signed in
    const user = userCredential.user;
    console.log(user.uid);
    // ...
  })
  .catch((error) => {
    const errorCode = error.code;
    const errorMessage = error.message;
  });
